import axios from "axios"

const API_URL = process.env.NEXT_PUBLIC_STATIC_BASE_API_URL
export const axiosInstance = axios.create({
	baseURL: API_URL,
	headers: {
		Accept: "application/json",
		"Content-Type": "application/json",
	},
})
